const config = Object.freeze(require("./app.config.json"));

export default config;